/**
 * @Description 点位测评
 */

import { get, post } from '@/common/request/index';

/**
 * 根据经纬度获得省市区poi名称
 * https://yapi.lanhanba.com/project/469/interface/api/75172
 */
export function postAmapLocation(params?: any, config?: any) {
  return post('/v2/amap/location', { ...params }, {
    // isMock: true,
    needHint: true,
    needCancel: false,
    isTerra: false,
    ...config
  });
}
/**
 * 小拇指卡片信息详情
 * https://yapi.lanhanba.com/project/349/interface/api/75221
 */
export function postSpotEvaluationDetail(params?: any, config?: any) {
  return post('/v2/spot/evaluation/detail', { ...params }, {
    isMock: false,
    mockId: 349,
    mockSuffix: '/api',
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 小拇指业态分布信息
 * https://yapi.lanhanba.com/project/349/interface/api/75242
 */
export function postSpotEvaluationBusinessDistribution(params?: any, config?: any) {
  return post('/v2/spot/evaluation/businessDistribution', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 经营门店tab
 * https://yapi.lanhanba.com/project/349/interface/api/77678
 */
export function postSpotEvaluationPOILevelCount(params?: any, config?: any) {
  return post('/v2/spot/evaluation/levelCount', { ...params }, {
    isMock: false,
    mockId: 349,
    mockSuffix: '/api',
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 点位测评-竞品品牌列表【APP】
 * https://yapi.lanhanba.com/project/349/interface/api/77916
 */
export function postSpotEvaluationCompetitorsPage(params?: any, config?: any) {
  return post('/v2/spot/evaluation/competitorsPage', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 知名品牌分享
 */
export function postFamousBrandPage(params?: any, config?: any) {
  return post('/v2/spot/evaluation/brandPage', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 经营门店明细
 * https://yapi.lanhanba.com/project/349/interface/api/75333
 */
export function postSpotEvaluationPOILevelPage(params?: any, config?: any) {
  return post('/v2/spot/evaluation/levelPage', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 客流画像
 * https://yapi.lanhanba.com/project/349/interface/api/75417
 */
export function postSpotEvaluationPopulation(params?: any, config?: any) {
  return post('/v2/spot/evaluation/population', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 周边配套 tab接口（返回一二级tab及对应数量）
 * https://yapi.lanhanba.com/project/349/interface/api/75438
 */
export function postSpotEvaluationArroundCategory(params?: any, config?: any) {
  return post('/v2/spot/evaluation/arroundCategory', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 周边配套 poi分页列表
 * https://yapi.lanhanba.com/project/349/interface/api/75445
 */
export function postSpotEvaluationArroundPage(params?: any, config?: any) {
  return post('/v2/spot/evaluation/arroundPage', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

// ========================================================分享相关接口=========================================================

/**
 * 小拇指卡片信息详情
 * https://yapi.lanhanba.com/project/349/interface/api/75221
 */
export function postSpotEvaluationDetailShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/detail', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 小拇指业态分布信息
 * https://yapi.lanhanba.com/project/349/interface/api/75242
 */
export function postSpotEvaluationBusinessDistributionShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/businessDistribution', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 经营门店tab
 * https://yapi.lanhanba.com/project/349/interface/api/75263
 */
export function postSpotEvaluationLevelCountShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/levelCount', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 点位测评-竞品品牌列表-分享【APP】
 * https://yapi.lanhanba.com/project/349/interface/api/77923
 */
export function postSpotEvaluationCompetitorsPageShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/competitorsPage', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 知名品牌分享
 */
export function postFamousBrandPageShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/brandPage', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 经营门店明细
 * https://yapi.lanhanba.com/project/349/interface/api/75333
 */
export function postSpotEvaluationLevelPageShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/levelPage', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 客流画像
 * https://yapi.lanhanba.com/project/349/interface/api/75417
 */
export function postSpotEvaluationPopulationShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/population', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 点位测评-周边配套tab-分享【APP】
 * https://yapi.lanhanba.com/project/349/interface/api/77720
 */
export function postSpotEvaluationArroundCategoryShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/arroundCategory', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 周边配套 poi分页列表
 * https://yapi.lanhanba.com/project/349/interface/api/75445
 */
export function postSpotEvaluationArroundPageShare(params?: any, config?: any) {
  return post('/v2/spot/evaluation/share/arroundPage', { ...params }, {
    // isMock: true,
    needHint: true,
    isTerra: false,
    ...config
  });
}

/**
 * 创建短链 并返回分享id
 * https://yapi.lanhanba.com/project/532/interface/api/76957
 */
export function getShareId(params?: any, config?: any) {
  return post('/v2/share/shortLink/createShortLink', { ...params }, {
    needHint: true,
    needCancel: false,
    ...config
  });
}

/**
 * 批量创建短链
 * https://yapi.lanhanba.com/project/623/interface/api/92395
 */
export function getShareBatchCreateShortLink(params?: any, config?: any) {
  return post('/v2/share/shortLink/batchCreateShortLink', { ...params }, {
    needHint: true,
    needCancel: false,
    ...config
  });
}

/**
 * 根据分享id获取请求体内容
 * https://yapi.lanhanba.com/project/532/interface/api/76964
 */
export function getShareContent(params?: any, config?: any) {
  return get('/v2/share/shortLink/getShortLinkInfo', { ...params }, {
    needHint: true,
    needCancel: false,
    ...config,
  });
}

/**
 * 保存查询记录 （找雪飞，暂无文档）
 */
export function saveRecord(params?: any, config?: any) {
  return post('/v2/spot/evaluation/saveRecord', { ...params }, {
    needHint: true,
    ...config
  });
}

/**
 * 保存查询记录 （找雪飞，暂无文档）
 */
export function getMallShopList(params?: any, config?: any) {
  return post('/v2/spot/evaluation/mallShop/pageList', { ...params }, {
    needHint: true,
    ...config
  });
}

/**
 * 点位测评-获取配置信息
 * https://yapi.lanhanba.com/project/349/interface/api/92748
 */
export function getSpotEvaluationConfigData(params:any) {
  return get('/v2/spot/evaluation/configData', params, { isMock: false, mockId: 349, mockSuffix: '/api', needHint: true, isTerra: true });
}

/**
 * 点位测评-获取配置信息-分享
 * https://yapi.lanhanba.com/project/349/interface/api/92748
 */
export function getSpotEvaluationShareConfigData(params:any) {
  return get('/v2/spot/evaluation/share/configData', params, { isMock: false, mockId: 349, mockSuffix: '/api', needHint: true, isTerra: true });
}
